import type { AnalyticsSearchStatsRecord } from '~/services/AnalyticsService';

export type GroupedSearchStats = {
  naturalLanguageQuery: string;
  count: number;
  firstSearchId: string;
  destinationIds: Array<string>;
  landmarkIds: Array<string>;
  propertyIds: Array<string>;
  prefixMatchedGeometryNames: Array<string>;
  prefixMatchedOfferNames: Array<string>;
};

function uniqueFirstSeenOrder(ids: Array<string>): Array<string> {
  const seen = new Set<string>();
  const result: Array<string> = [];

  for (const id of ids) {
    if (!seen.has(id)) {
      seen.add(id);
      result.push(id);
    }
  }

  return result;
}

export function groupSearchStatsByQuery(records: Array<AnalyticsSearchStatsRecord>): Array<GroupedSearchStats> {
  const buckets = new Map<string, Array<AnalyticsSearchStatsRecord>>();

  for (const record of records) {
    const bucket = buckets.get(record.naturalLanguageQuery);
    if (bucket) {
      bucket.push(record);
    } else {
      buckets.set(record.naturalLanguageQuery, [record]);
    }
  }

  const groups = Array.from(buckets.entries()).map(([naturalLanguageQuery, bucket]) => ({
    naturalLanguageQuery,
    count: bucket.length,
    firstSearchId: bucket[0].searchId,
    destinationIds: uniqueFirstSeenOrder(bucket.flatMap((record) => record.destinationIds)),
    landmarkIds: uniqueFirstSeenOrder(bucket.flatMap((record) => record.landmarkIds)),
    propertyIds: uniqueFirstSeenOrder(bucket.flatMap((record) => record.propertyIds)),
    prefixMatchedGeometryNames: uniqueFirstSeenOrder(bucket.flatMap((record) => record.prefixMatchedGeometryNames)),
    prefixMatchedOfferNames: uniqueFirstSeenOrder(bucket.flatMap((record) => record.prefixMatchedOfferNames)),
  }));

  groups.sort((a, b) => b.count - a.count);

  return groups;
}
